import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { Trash2, Edit, Plus, Download, Eye, Printer } from "react-feather";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import QRScannerInput from "./QRScannerInput";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
} from "reactstrap";
import SingleSelect from "../../SingleSelect/SingleSelect";
import { Btn, H5, P } from "../../../AbstractElements";
import axios from "axios";
import { FontSize } from "../../../Constant";

const user_options = ["Name", "Province", "District"];

const FilterComponent = ({
  filterText,
  onFilter,
  onClear,
  userOption,
  setSelectedUserOption,
  t,
}) => (
  <div style={{ display: "flex", flexDirection: "row" }}>
    <SingleSelect
      options={user_options}
      selectedOption={userOption}
      onChange={setSelectedUserOption}
    />
    <input
      className="form-control"
      placeholder={userOption === 'District'? t("Filter by District") : userOption === 'Name'? t("Filter by Name") : userOption === 'Province'? t("Filter by Province") : t("Filter by Status") }
      aria-label="Search Input"
      style={{ width: "250px", paddingLeft: "5px" }}
      name="phone"
      id="search"
      type="text"
      value={filterText}
      onChange={onFilter}
    />
    <Btn attrBtn={{ onClick: onClear }} type="button">
      X
    </Btn>
  </div>
);

const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [data, setData] = useState();
  const [user_id, setUserId] = useState();
  const { t } = useTranslation();
  const [scanMessage, setScanMessage] = useState("");
  const pres = localStorage.getItem("pres");
  const [modal, setModal] = useState(false);
  const [userOption, setSelectedUserOption] = useState("Name");
  const toggle = (e) => {
    e.preventDefault();
    setModal(!modal);
  };
  const [filteredItems, setFilteredItems] = useState();
  useEffect(() => {
    handle_get_firms();
  }, []);

  const user_options = ["NADA Office", "President", "Member"];

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get(
        "https://api-portal.nada.org.np/api/firms",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response2?.data?.success) {
        const filteredFirms = response2?.data?.data?.firms?.filter(item => item?.status === 3);
        setData(filteredFirms);
        setFilteredItems(filteredFirms);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);


  const handleScan = async (qrCode) => {
    try {
      const response2 = await axios.get(
        `https://api-portal.nada.org.np/api/proxies/doc/scan/${qrCode}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response2?.data?.success) {
        toast.success(response2?.data?.message);
        setScanMessage(response2?.data?.message);
        setModal(!modal);
        //window.open(response2?.data?.data?.doc, "_blank", "noopener,noreferrer");
      } else {
        toast.error("Document couldn't be verified");
        setScanMessage(response2?.data?.message);
        setModal(!modal);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
};


  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
        <QRScannerInput onScan={handleScan} />
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t("Verify Document")}</H5>
                {/*
                  <Btn
                    attrBtn={{ color: "primary", onClick: handleAddNewClick }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Add New
                  </Btn>
                */}
              </CardHeader>
              <CardBody>
                {/*data && (
                  <DataTable
                    data={filteredItems}
                    columns={tableColumns}
                    striped={true}
                    center={true}
                    persistTableHead
                    subHeader
                    selectableRows
                    subHeaderComponent={subHeaderComponentMemo}
                    paginationResetDefaultPage={resetPaginationToggle}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    pagination
                    customStyles={customStyles}
                  />
                )*/}
                <P>{t("Please scan the qr. If the doc is verified, it will be opened in new tab.")}</P>
                <br />
                <P>{t("To Scan another qr, please refresh the page")}</P>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
        isOpen={modal}
        toggle={toggle}
        //size={props.size}
        centered
      >
        <ModalHeader toggle={toggle}>{t("Scan Result")}</ModalHeader>
        <ModalBody
        //className={props.bodyClass}
        >
          <Label className="form-label">{scanMessage}</Label>
        </ModalBody>
        <ModalFooter>
          <Btn attrBtn={{ color: "secondary", onClick: toggle, height: 65 }}>
            {t("Close")}
          </Btn>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};
export default DataTablesContain;
